import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { format } from 'date-fns';
import { el } from 'date-fns/locale';
import { Message, MessageService } from 'primeng/api';
import { Subject, Subscription } from 'rxjs';
import { STATUS } from '../../models/loading-status.enum';
import { AuthService } from '../../../../services/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { LoginMessages } from '../../../../../assets/data/login-messages';
import { authFormConfig } from './auth.config';
import { ErrorMessageService } from '../../error-message.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
  appTitle = environment.appTitle;
  appSubtitle = environment.appSubtitle;

  STATUS = STATUS;
  subscriptions: Subscription[] = [];
  today = format(new Date(), 'iiii dd/MM/yyyy', { locale: el });
  isStageEnvironment =
    window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
    window.location.href.indexOf('local') !== -1
      ? true
      : false;

  authFormConfig = authFormConfig;
  form = this.fB.group(authFormConfig.getFormGroup());

  authForm: { username: string; password: string; doctorSpecialtyID: number };
  submitted = false;

  appVersion = environment.appVersion;

  username = '';
  announcements: Message[] = [
    {
      severity: 'warn',
      summary: '',
      detail: `Παρατηρούνται προβλήματα ασυμβατότητας με τη χρήση SAFARI Web browser. Παρακαλώ εναλλακτικά χρησιμοποιήστε έναν από τους συμβατούς web browsers που αναφέρονται στο site του ΕΟΠΥΥ.`,
      sticky: true,
      closable: false,
    },
    {
      severity: 'info',
      summary: '',
      detail: `TEST 2`,
      sticky: true,
      closable: false,
    },
  ];
  errorMessages: Message[] = [];

  status$ = this.authService.loginStatus$;
  token$ = this.authService.token$;
  tokenStatus$ = this.authService.tokenStatus$;
  tokenError$ = this.authService.tokenError$;
  loginError$ = this.authService.loginError$;
  alertMessage: Message[] = [];

  constructor(
    private readonly router: Router,
    private readonly fB: FormBuilder,
    private route: ActivatedRoute,
    private readonly authService: AuthService,
    private messageService: MessageService,
    private errorMessageService: ErrorMessageService
  ) {
    this.authForm = { username: '', password: '', doctorSpecialtyID: 0 };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const refParam: string = params['ref'];
      this.setAlertMessage(refParam);
      //console.log('ref:', refParam);
    });
    this.subscribeToStoreEffects();
  }

  subscribeToStoreEffects(): void {
    this.subscriptions = [
      this.token$.subscribe((t) => {
        if (!t) return;

        this.router.navigate(['home']);
        setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
      }),

      this.tokenError$.subscribe((e: any) => {
        if (!e) return;
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Αποτυχία σύνδεσης',
        //   detail: this.errorMessageService.getErrorMessage(e),
        //   life: 5000,
        // });
      }),
    ];
  }

  setAlertMessage(refParam: string): void {
    switch (refParam) {
      // case 'au':
      //   this.alertMessage = LoginMessages.ANAUTHORIZED;
      //   break;
      case 'so':
        this.messageService.add({
          severity: LoginMessages.SIGNOUT.Type,
          summary: LoginMessages.SIGNOUT.Message,
          detail: LoginMessages.SIGNOUT.Details,
        });
        break;
      case 're':
        this.messageService.add({
          severity: 'error',
          summary: 'Αποτυχία',
          detail: LoginMessages.REGISTERED.Message,
        });
        // this.alertMessage = [
        //   {
        //     severity: LoginMessages.REGISTERED.Type,
        //     detail: LoginMessages.REGISTERED.Message ?? '-',
        //   },
        // ];
        break;
      // case 'to':
      //   this.alertMessage = LoginMessages.TIMEOUT;
      //   break;
      // case 'rp': // Reset Pass
      //   this.alertMessage = LoginMessages.RESSETPASS;
      //   break;
      default:
        this.alertMessage = []; // Default alert message
        break;
    }
  }

  onSubmit(): void {
    this.errorMessages = [];

    let username = this.form.get('username')?.value ?? '';
    let password = this.form.get('password')?.value ?? '';
    this.authService.fetchToken(username, password);
  }

  OnRegister() {
    //this.status$.next('loading_register');
    window.location.href = environment.apiUrl + '/v1/ExternalLogin/Gsis';
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions?.forEach((s) => s.unsubscribe());
  }
}
